// extracted by mini-css-extract-plugin
export default {"background":"ErrorScreen_background__ojbSL","logo":"ErrorScreen_logo__YkF4t","floating":"ErrorScreen_floating__kIjcE"};